import Vibrant from 'node-vibrant';
import { BookInterface } from '../types/book';
import { useEffect,  useState } from 'react';

const imageLoadTracker: Record<string, Promise<HTMLImageElement>> = {};

interface SpineColours {
  [key: string]: string;
}

interface BookHeights {
  [key: string]: number;
}
export const getImage = (isbn: string): Promise<HTMLImageElement> => {
  if (!imageLoadTracker[isbn]) {
    imageLoadTracker[isbn] = new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        resolve(img);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = `https://zilu-cover-images.storage.googleapis.com/${isbn}.jpg`;
    });
  } 
  return imageLoadTracker[isbn];
};


export const useBookData = (books: BookInterface[], defaultWidth: number, isMobile: boolean = false) => {
  const effectiveWidth = isMobile ? 172 : defaultWidth; // 172px for mobile as in your BookTransition
  const defaultHeight = effectiveWidth * 1.5;
    const [bookHeights, setBookHeights] = useState<BookHeights>({});
    const [spineColours, setSpineColours] = useState<SpineColours>({});
    
    useEffect(() => {
      if (!books || books.length === 0) return;
      
      // Create a state object to track all book data loading
      const loadedData: {
        heights: BookHeights;
        colors: SpineColours;
      } = {
        heights: {},
        colors: {}
      };
      
      // Load all books in parallel
      Promise.all(
        books.map(book => 
          getImage(book.isbn_13)
            .then(img => {
              // Calculate proper height based on aspect ratio
              const aspectRatio = img.height / img.width;
              loadedData.heights[book.work_urn] = defaultWidth * aspectRatio;
              
              // Extract spine color
              return Vibrant.from(img).getPalette()
                .then(palette => {
                  const vibrantColor = palette.Vibrant?.rgb;
                  if (vibrantColor) {
                    const [r, g, b] = vibrantColor;
                    loadedData.colors[book.work_urn] = `rgb(${r}, ${g}, ${b})`;
                  } else {
                    loadedData.colors[book.work_urn] = '#888888'; // Fallback gray
                  }
                });
            })
            .catch(error => {
              console.error(`Error processing book ${book.work_urn}:`, error);
              // Set fallback values on error
              loadedData.heights[book.work_urn] = defaultHeight;
              loadedData.colors[book.work_urn] = '#888888';
            })
        )
      )
      .then(() => {
        // Set all data at once when everything is done
        setBookHeights(loadedData.heights);
        setSpineColours(loadedData.colors);
      });
      
    }, [books, defaultWidth]);
    
    return { bookHeights, spineColours };
  };